import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { compose } from 'recompose'

import {
  SettingsModal,
  ProfileDetailsModal,
  ChangePasswordModal,
  ChangeEmailModal
} from 'components/modals'
import { apiDashboard } from 'helpers/decorators/api'
import MODALS from 'constants/layout/modals'
import { modal } from 'helpers/decorators'
import { HIERARCHY_LEVELS } from 'constants/enums'

const enhance = compose(apiDashboard.apiPersons(), modal.trigger())

class MyProfile extends Component {
  static propTypes = {
    isAssessor: PropTypes.bool,
    profile: PropTypes.object,
    isRegLocalesEnabled: PropTypes.bool
  }

  render() {
    const { profile, isAssessor, isRegLocalesEnabled } = this.props
    const isInIac = get(profile, 'data.awards', []).some(
      item =>
        get(item, 'organization.hierarchyLevel', {}).value ===
        HIERARCHY_LEVELS.IAC.id
    )

    const isInNaoWithRegLoc = isDefaultLocaleSet(profile, 'organization.parentNAO.defaultLocaleId')

    const isInSoaWithRegLoc = isDefaultLocaleSet(profile, 'organization.parentSubOA.defaultLocaleId')

    const isInOaWithRegLoc = isDefaultLocaleSet(profile, 'organization.parentOA.defaultLocaleId')

    const isRegLocEnabled = isInNaoWithRegLoc || isInSoaWithRegLoc || isInOaWithRegLoc || isRegLocalesEnabled

    return (
      <div>
        <ProfileDetailsModal
          modalId={MODALS.PROFILE_DETAILS}
          profile={profile}
          isAssessor={isAssessor}
        />
        <ChangePasswordModal
          modalId={MODALS.CHANGE_PASSWORD}
          profile={profile}
        />
        <ChangeEmailModal
          modalId={MODALS.CHANGE_EMAIL}
          isAssessor={isAssessor}
          profile={profile}
        />
        <SettingsModal modalId={MODALS.SETTINGS} isInIac={isInIac} isRegLocEnabled={isRegLocEnabled} />
      </div>
    )
  }
}

function isDefaultLocaleSet(profile, path) {
  return get(profile, 'data.awards', []).some(
    item =>
      get(item, path, 0) > 0
  )
}

export default enhance(MyProfile)
